// web/src/pages/UsuariosCreate.jsx
import React from "react";
import Sidebar from "../components/layout/Sidebar";
import Topbar from "../components/layout/Topbar";

import "./BaseLayout.css";
import "./UsuariosCreate.css";

export default function UsuariosCreate() {
  return (
    <div className="page-wrapper">
      <Sidebar />

      <div className="page-content">
        <Topbar />

        <div className="usuarios-create-container">
          <header className="usuarios-create-header">
            <h1 style={{ color: "#999" }}>Tela desativada</h1>
            <p style={{ color: "#777" }}>
              A funcionalidade de criar usuário foi desativada e será removida
              em breve.  
              <br />
              Uma nova tela de <strong>criação de atendente</strong> será adicionada.
            </p>
          </header>

          {/* 
          ======================================================================
          TELA ORIGINAL — TOTALMENTE INATIVADA
          (todo código foi mantido, mas comentado em verde)
          ======================================================================

          import React, { useState } from "react";
          import UserForm from "../components/users/UserForm";
          import { createUserWithProfile } from "../services/userService";

          const [loading, setLoading] = useState(false);
          const [feedback, setFeedback] = useState(null);

          async function handleCreateUser(data) {
            setLoading(true);
            setFeedback(null);
            try {
              await createUserWithProfile(data);
              setFeedback({
                type: "success",
                message: `Usuário ${data.name} criado com sucesso!`,
              });
            } catch (error) {
              console.error("Erro ao criar usuário:", error);
              setFeedback({
                type: "error",
                message:
                  error.message ||
                  "Ocorreu um erro ao criar o usuário. Tente novamente.",
              });
            } finally {
              setLoading(false);
            }
          }

          <div className="usuarios-create-card">
            <UserForm onSubmit={handleCreateUser} loading={loading} />
          </div>
          ======================================================================
          */}
        </div>
      </div>
    </div>
  );
}
